import { render, staticRenderFns } from "./MarketTicker.vue?vue&type=template&id=1a1ee817&scoped=true"
import script from "./MarketTicker.vue?vue&type=script&lang=js"
export * from "./MarketTicker.vue?vue&type=script&lang=js"
import style0 from "./MarketTicker.vue?vue&type=style&index=0&id=1a1ee817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ee817",
  null
  
)

export default component.exports